import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './Contact.scss';
import ContactInput from './ContactInput';
import ContactSearch from './ContactSearch';
import ContactTable from './ContactTable';
import { setTriggerRefreshInput, setTriggerSave } from './reducers/ContactInputReducer';
import { resetContactSearch, setTriggerContactSearch } from './reducers/ContactSearchReducer';

let triggerHotkeyAlready = false;

const Contact: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    useEffect(() => {
        document.title = "Contact";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSave((new Date()).getTime()));
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerContactSearch((new Date()).getTime()));
                        break;
                    case "q":
                        //refresh search
                        dispatch(resetContactSearch());
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid item lg={2} xs={12} className="left-search-area">
                    <ContactSearch></ContactSearch>
                </Grid>
                <Grid item lg={10} xs={12} className="right-content">
                    <Grid container className="input-fields">
                        <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                            <ContactInput></ContactInput>
                        </div>
                    </Grid>
                    <Grid container className="datatable">
                        <ContactTable>
                        </ContactTable>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default Contact;